module.exports = __webpack_public_path__ + "img/survey.b5f8962b.png";